
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QRyStockcardGrid extends Serenity.EntityGrid<QRyStockcardRow, any> {
        // protected getColumnsKey() { return QRyStockcardColumns.columnsKey; }
        protected getDialogType() { return QRyStockcardDialog; }
        protected getIdProperty() { return QRyStockcardRow.idProperty; }
        protected getInsertPermission() { return QRyStockcardRow.insertPermission; }
        protected getLocalTextPrefix() { return QRyStockcardRow.localTextPrefix; }
        protected getService() { return QRyStockcardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}